import React, { useEffect } from 'react';

import {
  Box,
  ListItem,
  SimpleGrid,
  Stack,
  UnorderedList,
} from '@chakra-ui/react';
import round from 'lodash/round';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { customTheme } from 'theme';

import { IconTypes } from 'components/Icons';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import { selectIdentityOverview } from 'containers/Dashboard/IdentityOverview/selectors';
import { ResourceIconAndCountProps } from 'containers/Dashboard/types';
import {
  DashboardWidgetTooltipIcon,
  renderResourcesWithIconAndCount,
} from 'containers/Dashboard/utils/utils';

export const JITAccessRequests: React.FC = () => {
  const { jitSummary } = useSelector(selectIdentityOverview);
  const { data } = jitSummary;
  const navigate = useNavigate();
  const [totalRequests, setTotalRequests] = React.useState(0);
  const [cloudAccounts, setCloudAccounts] = React.useState(0);
  const [saasAccounts, setSaasAccounts] = React.useState(0);

  useEffect(() => {
    setTotalRequests(
      (data?.approved_requests_count ?? 0) + (data?.denied_requests_count ?? 0),
    );
  }, [data]);

  const items: ResourceIconAndCountProps[] = [
    {
      label: 'Cloud Accounts enabled',
      count: data?.jit_enabled_count ?? 0,
      iconColor: customTheme.colors.blue['300'],
      iconType: IconTypes.Account,
      onClick: () => navigate('/jit/setup'),
    },
  ];

  const requestItems = [
    {
      label: 'Requests received',
      count: data?.requests_count ?? 0,
      iconColor: customTheme.colors.blue['300'],
      iconType: IconTypes.Clock,
      onClick: () => navigate('/jit/requests'),
    },
    {
      label: 'Requests approved',
      count:
        (data?.approved_requests_count ?? 0) +
        ' (' +
        (!!totalRequests
          ? round((data?.approved_requests_count / totalRequests) * 100, 0)
          : 0) +
        '%)',
      iconColor: customTheme.colors.green['300'],
      iconType: IconTypes.ThumbsUp,
      onClick: () => navigate('/jit/requests'),
    },
    {
      label: 'Requests denied',
      count:
        (data?.denied_requests_count ?? 0) +
        ' (' +
        (!!totalRequests
          ? round(
              (jitSummary.data?.denied_requests_count / totalRequests) * 100,
              0,
            )
          : 0) +
        '%)',
      iconColor: customTheme.colors.high,
      iconType: IconTypes.ThumbsDown,
      onClick: () => navigate('/jit/requests'),
    },
  ];

  return (
    <DashboardWidget
      label="Just-in-Time (JiT) Access Management"
      subHeader={
        'Enabled for ' +
        (jitSummary.data?.jit_enabled_count ?? 0) +
        ' accounts, Last 30 days activity'
      }
      //jitEnabled={!!jitSummary.data?.jit_enabled_count}
      /*rightHeader={
        <Box w="full" pr={2}>
          {renderCloudIcons(jitSummary.data?.cloud_providers)}
        </Box>
      }*/
      /*content={
        !jitSummary.data?.jit_enabled_count ? (
          <HStack
            spacing={4}
            align="flex-start"
            fontSize="md"
            justify="center"
            pb={6}
            maxW="55%"
          >
            <Box boxSize={10} color="orange">
              <Center>
                <CustomerJourneyBulbIcon />
              </Center>
            </Box>
            <Stack spacing={4} flex={1}>
              <Box color="primary" cursor="pointer">
                JIT management not enabled for Cloud or SaaS accounts
              </Box>
              <Box>
                <PrimaryButton onClick={() => navigate('/jit/setup/add')}>
                  ENABLE
                </PrimaryButton>
              </Box>
            </Stack>
          </HStack>
        ) : (
          <HStack w="full" h="full" spacing={10} p={2}>
            {map(items, o => (
              <VerticalCountCard {...o} />
            ))}
          </HStack>
        )
      }*/
      content={
        <Box w="full" h="full">
          <SimpleGrid columns={[2]} gridAutoRows="max-content">
            {renderResourcesWithIconAndCount(items)}
            {renderResourcesWithIconAndCount(requestItems)}
          </SimpleGrid>
        </Box>
      }
      isLoading={jitSummary.isLoading}
      tooltip={{
        tooltip: (
          <Stack spacing={3}>
            <Box>
              JIT permissions allows you to provide just-in-time access to cloud
              and SaaS. This eliminates the timebound risk due to excess
              permissions given to users.
            </Box>
            <Box>You can:</Box>
            <UnorderedList color="primary" spacing={2}>
              <ListItem pl={2}>Enable JIT for an account</ListItem>
              <ListItem pl={2}>Provide fine-grained privileges</ListItem>
              <ListItem pl={2}>Approve using messaging apps</ListItem>
            </UnorderedList>
          </Stack>
        ),
        header: 'JIT Permission Management',
        showArrow: false,
        button: <DashboardWidgetTooltipIcon />,
      }}
      styles={{ contentWrapper: { px: 0, pb: 0 } }}
    />
  );
};
